/**
 * Singleton provider for Base network public RPC access.
 * Reuses a single JsonRpcProvider instance to avoid creating new HTTP connections
 * on every TanStack Query refetch.
 */
import { ethers } from 'ethers';
import { env } from '@/lib/env';

let cachedProvider: ethers.JsonRpcProvider | null = null;
let cachedPolygonProvider: ethers.JsonRpcProvider | null = null;

export function getBaseProvider(): ethers.JsonRpcProvider {
  if (!cachedProvider) {
    const rpcUrl = env.baseRpcUrl;
    if (!rpcUrl) {
      throw new Error('Base RPC URL not configured');
    }
    cachedProvider = new ethers.JsonRpcProvider(rpcUrl);
  }
  return cachedProvider;
}

export function getPolygonProvider(): ethers.JsonRpcProvider {
  if (!cachedPolygonProvider) {
    const rpcUrl = env.polygonRpcUrl;
    if (!rpcUrl) {
      throw new Error('Polygon RPC URL not configured');
    }
    cachedPolygonProvider = new ethers.JsonRpcProvider(rpcUrl);
  }
  return cachedPolygonProvider;
}

/** Reset all cached providers (for test isolation) */
export function resetProvider(): void {
  cachedProvider = null;
  cachedPolygonProvider = null;
}
